import { createElement, lazy, type ComponentType, type LazyExoticComponent } from "react";
import NeedsConnection from "./NeedsConnection";

/**
 * Like React.lazy, but a failed chunk fetch (typical offline) renders a clear
 * “needs a connection” panel instead of tripping the app ErrorBoundary.
 */
export function lazyScreen<P extends object>(
  loader: () => Promise<{ default: ComponentType<P> }>,
  options?: { compact?: boolean },
): LazyExoticComponent<ComponentType<P>> {
  const compact = !!options?.compact;
  return lazy(() =>
    loader().catch(() => ({
      default: ((_props: P) =>
        createElement(NeedsConnection, {
          compact,
          title: compact ? "Chart unavailable offline" : undefined,
          detail: compact
            ? "Reconnect to load this chart, or open it once while online."
            : undefined,
        })) as ComponentType<P>,
    })),
  );
}
